import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { selectors } from '../../Stream';
import { getDataEntities } from '../../redux/entities/selectors';
import { reduxKey, streamId } from './constants';
function getStoreSlice(state) {
    return state[reduxKey] || {
        isNewCollectionSaving: false,
        deviations: {}
    };
}
function getUserCollectionEntities(state) {
    const { collections  } = getDataEntities(state);
    if (!collections) {
        return {};
    }
    return collections;
}
function getCollectionsRaw(state) {
    const collectionIds = selectors.getItems(state, streamId) || [];
    if (!collectionIds.length) {
        return [];
    }
    return getCollectionsByFolderId(state, collectionIds);
}
function getCollectionsByFolderId(state, folderIds) {
    const collections = getUserCollectionEntities(state);
    return folderIds.filter((id)=>collections.hasOwnProperty(id)).map((collectionId)=>collections[collectionId]);
}
function getChangeType(added, removed, kept) {
    if (!added) {
        if (!removed) {
            return 'none';
        }
        if (!kept) {
            return 'removeAll';
        }
        if (removed === 1) {
            return 'removeOne';
        }
        return 'removeSome';
    }
    if (removed) {
        return 'misc';
    }
    if (added > 1) {
        return 'addMany';
    }
    return 'addOne';
}
function getDeviationState(state, deviationId) {
    const slice = getStoreSlice(state);
    return slice === null || slice === void 0 ? void 0 : slice.deviations[deviationId];
}
export function getCollection(state, folderId) {
    return getUserCollectionEntities(state)[folderId];
}
export function getUserCollections(state, deviationId) {
    const slice = getDeviationState(state, deviationId);
    const collections = slice ? getCollectionsRaw(state).map((collection)=>_object_spread_props(_object_spread({}, collection), {
            isSelected: slice.selectedCollections.includes(collection.folderId)
        })) : [];
    var _slice_isInitializedForCollecting;
    const streamInfo = {
        streamId,
        isInitialized: (_slice_isInitializedForCollecting = slice === null || slice === void 0 ? void 0 : slice.isInitializedForCollecting) !== null && _slice_isInitializedForCollecting !== void 0 ? _slice_isInitializedForCollecting : false,
        hasMore: selectors.hasMore(state, streamId),
        isFetching: selectors.isFetching(state, streamId),
        errorMsg: selectors.getErrorMsg(state, streamId),
        collections
    };
    return streamInfo;
}
export function getUserCollectionsHasMore(state, deviationId) {
    var _getUserCollections;
    return !!((_getUserCollections = getUserCollections(state, deviationId)) === null || _getUserCollections === void 0 ? void 0 : _getUserCollections.hasMore);
}
export function getUserCollectionsCount(state, deviationId) {
    var _getUserCollections, _getUserCollections_collections;
    var _getUserCollections_collections_length;
    return (_getUserCollections_collections_length = (_getUserCollections = getUserCollections(state, deviationId)) === null || _getUserCollections === void 0 ? void 0 : (_getUserCollections_collections = _getUserCollections.collections) === null || _getUserCollections_collections === void 0 ? void 0 : _getUserCollections_collections.length) !== null && _getUserCollections_collections_length !== void 0 ? _getUserCollections_collections_length : 0;
}
export function getIsNewCollectionSaving(state) {
    return getStoreSlice(state).isNewCollectionSaving;
}
export function getUpdatedEntities(state, deviationId) {
    const entities = {
        collections: {}
    };
    const deviationState = getDeviationState(state, deviationId);
    var _deviationState_savedCollections;
    const currentFolders = (_deviationState_savedCollections = deviationState === null || deviationState === void 0 ? void 0 : deviationState.savedCollections) !== null && _deviationState_savedCollections !== void 0 ? _deviationState_savedCollections : [];
    var _deviationState_selectedCollections;
    const selectedFolders = (_deviationState_selectedCollections = deviationState === null || deviationState === void 0 ? void 0 : deviationState.selectedCollections) !== null && _deviationState_selectedCollections !== void 0 ? _deviationState_selectedCollections : [];
    const addedFolders = selectedFolders.filter((id)=>!currentFolders.includes(id));
    const removedFolders = currentFolders.filter((id)=>!selectedFolders.includes(id));
    const collections = getUserCollectionEntities(state);
    const updateFolderSize = (sizeChange, folderId)=>{
        if (!collections[folderId]) {
            return;
        }
        entities.collections[folderId] = _object_spread_props(_object_spread({}, collections[folderId]), {
            size: collections[folderId].size + sizeChange
        });
    };
    addedFolders.forEach(updateFolderSize.bind(1));
    removedFolders.forEach(updateFolderSize.bind(-1));
    return entities;
}
export function getNewFolderNameBlacklist(state) {
    const collections = getCollectionsRaw(state);
    return collections.map((collection)=>collection.name);
}
export function getIsDeviationInitialized(state, deviationId) {
    const slice = getStoreSlice(state);
    return slice.deviations.hasOwnProperty(deviationId) && slice.deviations[deviationId].isInitializedForCollecting;
}
export function getSelectedFolderIds(state, deviationId) {
    const slice = getDeviationState(state, deviationId);
    var _slice_selectedCollections;
    return (_slice_selectedCollections = slice === null || slice === void 0 ? void 0 : slice.selectedCollections) !== null && _slice_selectedCollections !== void 0 ? _slice_selectedCollections : [];
}
export function getFeaturedId(state) {
    const collections = getCollectionsRaw(state);
    const featured = collections.find((f)=>f.name === 'Featured');
    return featured && featured.folderId;
}
export function getChangeDetails(state, deviationId) {
    var _getDeviationState;
    const { selectedCollections: selected = [] , savedCollections: saved = [] , isFavourite: wasFavourite = false  } = (_getDeviationState = getDeviationState(state, deviationId)) !== null && _getDeviationState !== void 0 ? _getDeviationState : {};
    const added = selected.filter((f)=>!saved.includes(f));
    const removed = saved.filter((f)=>!selected.includes(f));
    const kept = saved.filter((f)=>selected.includes(f));
    const willBeFavourite = selected.length > 0;
    return {
        added,
        removed,
        selected,
        saved,
        changeType: getChangeType(added.length, removed.length, kept.length),
        wasFavourite,
        willBeFavourite
    };
}
// TODO: just kill this, it's terrible for perf
// @deprecated
export function getDeviationPatchedWithStoreState(state, deviation) {
    const slice = getStoreSlice(state).deviations[deviation.deviationId];
    if (!slice) {
        return deviation;
    }
    return _object_spread_props(_object_spread({}, deviation), {
        isFavourited: slice.isFavourite,
        stats: deviation.stats && _object_spread_props(_object_spread({}, deviation.stats), {
            favourites: slice.faveCount
        })
    });
}
export function getIsFavourite(state, deviation) {
    const slice = getDeviationState(state, deviation.deviationId);
    var _slice_isFavourite, _ref;
    return (_ref = (_slice_isFavourite = slice === null || slice === void 0 ? void 0 : slice.isFavourite) !== null && _slice_isFavourite !== void 0 ? _slice_isFavourite : deviation.isFavourited) !== null && _ref !== void 0 ? _ref : false;
}
export function getFaveCount(state, deviation) {
    var _deviation_stats;
    const slice = getDeviationState(state, deviation.deviationId);
    var _slice_faveCount, _ref;
    return (_ref = (_slice_faveCount = slice === null || slice === void 0 ? void 0 : slice.faveCount) !== null && _slice_faveCount !== void 0 ? _slice_faveCount : (_deviation_stats = deviation.stats) === null || _deviation_stats === void 0 ? void 0 : _deviation_stats.favourites) !== null && _ref !== void 0 ? _ref : 0;
}
export function getIsFaveLoading(state, deviation) {
    const slice = getDeviationState(state, deviation.deviationId);
    var _slice_isLoading;
    return (_slice_isLoading = slice === null || slice === void 0 ? void 0 : slice.isLoading) !== null && _slice_isLoading !== void 0 ? _slice_isLoading : false;
}
